import { useEffect, useRef } from 'react';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { pubSub } from 'utils/pubSub';
import { commandPubSubEventNamePrefix } from '../utils/commandUtils';
/** A hook for assigning a handler to a command. */
export function useCommandHandler(options) {
    const { name, actionFn } = options;
    const { newKeybindings } = useFeatureFlag(['new-keybindings']);
    const pubSubEventName = `${commandPubSubEventNamePrefix}${name}`;
    const pubSubHandler = useRef(actionFn);
    // Handles updating the current pubSub handler.
    useEffect(() => {
        pubSubHandler.current = actionFn;
    }, [actionFn]);
    // Handles subscribing to the pubSub event and executing the command.
    useEffect(() => {
        if (!newKeybindings) {
            return;
        }
        const unsubscribe = pubSub.subscribe(pubSubEventName, () => {
            pubSubHandler.current();
        });
        return () => {
            unsubscribe();
        };
    }, [newKeybindings, pubSubEventName]);
}
